import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { SYSTEM_ALLOWED_DATA_SOURCES } from './dataSourcePolicy.js';
import { MODULE_GROUP } from '../types/moduleGroup.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for ModuleGroup (per-org menu folders).
 * Stored in `org/{orgId}/module-groups`. Spec 0038 §3.3 / request 0148.
 */
export const moduleGroupDescriptor = {
    name: MODULE_GROUP,
    label: 'Grupo de Módulos',
    domain: 'modules',
    collectionPath: 'org/{orgId}/module-groups',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Per-organization menu group (presentation axis)',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: SYSTEM_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique group identifier within the organization',
        },
        {
            name: 'name',
            label: 'Nome',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Group display name',
        },
        {
            name: 'icon',
            label: 'Ícone',
            type: 'string',
            required: false,
            description: 'Icon identifier for UI display',
        },
        {
            name: 'description',
            label: 'Descrição',
            type: 'string',
            required: false,
            description: 'Optional group description',
        },
        {
            name: 'order',
            label: 'Ordem',
            type: 'number',
            required: false,
            description: 'Sort order among siblings',
        },
        {
            name: 'parentGroupId',
            label: 'Grupo Pai',
            type: 'string',
            required: false,
            description: 'Parent group id (undefined = root)',
        },
        {
            name: 'autoTags',
            label: 'Tags Automáticas',
            type: 'array',
            arrayItemType: 'string',
            required: false,
            description: 'Tags that auto-absorb entitled modules into this group',
        },
    ],
    foreignKeys: [
        {
            fieldName: 'parentGroupId',
            targetEntity: 'ModuleGroup',
            relationship: 'one-to-one',
            description: 'Parent group in the hierarchy',
        },
    ],
};
//# sourceMappingURL=moduleGroup.descriptor.js.map